<template>
  <DeleteAttachMeasureModal
    v-if="showDeleteAttachMeasureModal"
    :measureId="measure.id"
    :attachId="attachIdSelected"
    @closeModal="closeModal"
  />
  <div class="card border-start border-start-width-2 border-start-primary">
    <div class="card-body pb-0">
      <h5 class="text-center">Anexos</h5>
    </div>
    <div class="table-responsive">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th>Arquivo</th>
            <th class="text-end">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(attach, index) in measure.attachs" :key="index">
            <td>{{ attach.file }}</td>
            <td class="text-end">
              <button
                class="btn badge bg-danger my-1"
                title="Excluir"
                @click="deleteAttachMeasure(attach.id)"
              >
                Excluir
              </button>
              <a
                :href="`${pathFile}/${attach.measureId}/${attach.file}`"
                class="btn badge bg-primary my-1 ms-2"
                title="Download"
                target="_blank"
                download
              >
                Download
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card-body">
      <label class="form-label">
        Arquivo(s) em PDF: Nota fiscal, boleto e outros.
      </label>
      <div class="input-group">
        <input
          type="file"
          ref="newMeasureFile"
          class="form-control"
          multiple="multiple"
          accept="application/pdf"
          @change="onFilePicked"
        />
        <button
          type="button"
          class="btn btn-success ms-2"
          title="Adicionar Arquivo(s)"
          @click="addFiles"
        >
          Adicionar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import DeleteAttachMeasureModal from '@/components/documents/measures/DeleteAttachMeasureModal.vue'

export default {
  name: 'AttachsMeasure',

  props: {
    measure: {
      type: Object,
      required: true,
    },
  },

  components: {
    DeleteAttachMeasureModal,
  },

  emits: ['getMeasure'],

  data() {
    return {
      showDeleteAttachMeasureModal: false,
      pathFile: null,
      files: [],
      attachIdSelected: null,
    }
  },

  methods: {
    onFilePicked(event) {
      const { files } = event.target
      this.files = files
    },

    addFiles() {
      if (this.files.length > 0) {
        // eslint-disable-next-line no-restricted-syntax
        for (const file of this.files) {
          const fileReader = new FileReader()
          fileReader.addEventListener('load', () => {
            this.addAttachMeasure(file.name, fileReader.result)
          })
          fileReader.readAsDataURL(file)
        }

        this.files = []
        this.$refs.newMeasureFile.value = null
      } else {
        this.$root.$refs.notification.warning(
          'Selecione pelo menos um arquivo.',
        )
      }
    },

    async addAttachMeasure(name, attach) {
      try {
        const formData = new FormData()
        formData.append('measureId', this.measure.id)
        formData.append('name', name)
        formData.append('attach', attach)

        const response = await this.$store.dispatch(
          'addAttachMeasure',
          formData,
        )

        this.$root.$refs.notification.success(response.message)
        this.getMeasure()
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    deleteAttachMeasure(attachId) {
      this.attachIdSelected = attachId
      this.showDeleteAttachMeasureModal = true
    },

    closeModal(reloadMeasure) {
      if (reloadMeasure) {
        this.getMeasure()
      }
      this.showDeleteAttachMeasureModal = false
    },

    getMeasure() {
      this.$emit('getMeasure')
    },
  },

  mounted() {
    if (this.measure.type === 'Contrato') {
      this.pathFile = `${process.env.VUE_APP_BASE_URL_API}/uploads/contracts/${this.measure.contractId}/measures`
    } else {
      this.pathFile = `${process.env.VUE_APP_BASE_URL_API}/uploads/requests_new/${this.measure.idmov}/measures`
    }
  },
}
</script>
